import axios from "axios";

let BASE_URL;
if (process.env.NODE_ENV === "development") {
  BASE_URL = "https://api.ryan-funding.ir";
} else {
  BASE_URL = "https://api.ryan-funding.ir";
}

const instance = axios.create({
  baseURL: BASE_URL,
});

export default instance;

